import React, { useEffect, useState, useCallback, useMemo } from "react";
import Header from "../components/layouts/header";
import Footer from "../components/layouts/footer";

import { useLocation, useNavigate, Outlet, useMatch, useResolvedPath } from "react-router-dom";
import { useAuth, useCheckAuth } from "../app/useAuth";
import MenuComponent from "../components/Menu";
import styled from "@emotion/styled";

import api from "../api";
import { loginAuth } from "../app/auth";
import { useSelector, useDispatch } from "react-redux";

import Spinner from "react-bootstrap/Spinner";

const SearchMenuItem = (props) => {
    const navigate = useNavigate();
    const resolved = useResolvedPath(props.to);
    const rmatched = useMatch({ path: resolved.pathname, end: props.to === "/search" });

    const handleNavigate = useCallback(
        (e) => {
            e.preventDefault();
            navigate(props.to);
        },
        [props.to, navigate],
    );

    return (
        <a href="#" onClick={handleNavigate} className={`list-group-item ${rmatched && "active"}`}>
            {props.children}
        </a>
    );
};

const SearchMenu = () => {
    return (
        <div className="list-group">
            <SearchMenuItem to="/search">Search</SearchMenuItem>
            <SearchMenuItem to="/search/n1">Rice EST</SearchMenuItem>
            <SearchMenuItem to="/search/n4">DNA Marker</SearchMenuItem>
            <SearchMenuItem to="/search/n2">Genetic Maker Structural Variation</SearchMenuItem>
            <SearchMenuItem to="/search/n3">In-silico SNP Primer</SearchMenuItem>
            <SearchMenuItem to="/search/n5">Gene</SearchMenuItem>
            <SearchMenuItem to="/search/n7">SNV Data</SearchMenuItem>
            <SearchMenuItem to="/search/n6">Primer Validation</SearchMenuItem>
        </div>
    );
};

const SearchLayout = (props) => {
    const auth = useAuth();
    const navigator = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [authData, setAuthData] = useState("");
    const [verifyEmail, setVerifyEmail] = useState(false);
    const [loadingVerifyEmail, setLoadingVerifyEmail] = useState(false);

    const ignoreRouter = [
        "/",
        "/n1",
        "/n2",
        "/n3",
        "/n4",
        "/n5",
        "/n6",
        "/n7",
        "/login",
        "/forgot",
        "/reset",
        "/register",
        "/privacy",
        "/terms",
        "/email/verify/already-success",
    ];

    const checkRouter = useCallback((authData) => {
        if (authData === null) {
            if (!ignoreRouter.includes(location.pathname)) {
                navigator("/login");
            }
        }
    }, []);

    const fetchAuthLogin = useCallback(() => {
        api.get("/auth/myaccount")
            .then((response) => {
                const token = auth?.access_token;
                const data = response.data;

                const newAuthData = {
                    token: token,
                    auth_data: data,
                };

                dispatch(loginAuth(newAuthData));
                setLoadingVerifyEmail(false);
            })
            .catch((err) => {
                console.log(err);
                setLoadingVerifyEmail(false);
            });
    }, [api, auth, dispatch, loginAuth]);

    const resendVerify = useCallback(() => {
        setLoadingVerifyEmail(true);
        api.post("auth/email/verify/resend")
            .then((response) => {
                const data = response.data;
                if (data.message === "OK") {
                    alert("ระบบได้ส่งลิงก์ยืนยันตนไปยังอีเมลของท่านแล้ว");
                    setLoadingVerifyEmail(false);
                } else if (data.message === "Email verified") {
                    alert("อีเมลของท่านได้รับการยืนยันตนเรียบร้อยแล้ว");
                    fetchAuthLogin();
                }
            })
            .catch((err) => {
                console.log(err);
                setLoadingVerifyEmail(false);
            });
    }, [api, auth]);

    useEffect(() => {
        setAuthData(auth);
        checkRouter(auth);
        setVerifyEmail(auth?.auth_data?.email_verified_at ? false : true);
    }, [auth, checkRouter]);

    return (
        <div className="content" style={{ position: "relative" }}>
            <Header auth={authData} />

            <div className="container-text-to-image position-relative">
                <img
                    src={`${process.env.PUBLIC_URL}/assets/bg/DJI_0027.jpg`}
                    alt="DJI_0027"
                    style={{ width: "100%", height: 350, objectFit: "cover", objectPosition: "center" }}
                />

                <div className="position-absolute w-100 h-100 top-0 left-0">
                    <div className="container d-flex flex-column justify-content-center align-items-center">
                        <div className="mt-5">
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/cover/S__68960261.jpg`}
                                alt="S__68960261"
                                style={{ width: 150, borderRadius: 10 }}
                            />
                        </div>
                        <div className="h1 fw-bold mt-2" style={{ textShadow: "0 0 10px #000000" }}>
                            R-DNAM: Rice DNA Marker Database
                        </div>
                        <div className="h3 fw-bold" style={{ textShadow: "0 0 10px #000000" }}>
                            ฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว
                        </div>
                    </div>
                </div>

                <div className="position-absolute w-100 bottom-0 left-0">
                    <div className="container d-flex justify-content-center align-items-center">
                        <MenuComponent />
                    </div>
                </div>
            </div>

            <div className="container" style={{ minHeight: "calc(100vh - 468.2px)" }}>
                <div className="mt-5 d-flex flex-column flex-lg-row gap-5">
                    {verifyEmail ? (
                        <>
                            <div className="d-flex mw-100 py-5 h-100 flex-fill align-items-center justify-content-center">
                                <div style={{ width: 500, maxWidth: "100%" }}>
                                    <div className="alert alert-danger" role="alert">
                                        <h4 className="alert-heading">บัญชีผู้ใช้ยังไม่ได้รับการยืนยันอีเมล</h4>
                                        <p>ระบบได้ส่งลิงก์เพื่อยืนยันตนผ่านอีเมลของท่านแล้ว กรุณายืนยันตนผ่านทางอีเมลของท่านในกล่องจดหมาย</p>
                                        <hr />
                                        <div className="d-flex justify-content-start align-items-center flex-wrap">
                                            <p className="mb-0 mx-1">หากยังไม่มีจดหมายส่งถึงท่าน</p>

                                            {loadingVerifyEmail ? (
                                                <div className="mx-1">
                                                    <Spinner animation="border" variant="primary" />
                                                </div>
                                            ) : (
                                                <button
                                                    className="btn btn-primary btn-sm mx-1"
                                                    disabled={loadingVerifyEmail}
                                                    onClick={() => resendVerify()}
                                                >
                                                    คลิกเพื่อส่งลิงก์ยืนยันตนผ่านอีเมลอีกครั้ง
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div style={{ width: 300 }}>
                                <SearchMenu />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Outlet />
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* <div className="mt-5"></div>

            <div className="d-flex flex-column pt-5" style={{ minHeight: "calc(100vh - (468.2px + 80px))" }}>
                <Outlet />
            </div> */}

            <Footer />
        </div>
    );
};

export default SearchLayout;
